import {IconBox, IconProps} from "../index";
import React from "react";

import InstagramSvg from "../../../../assets/icons/social/instagram.svg?react";

export const InstagramIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <InstagramSvg/>
        </IconBox>
    );
}
